class Comments extends DrupalBehavior {

  onContent(context) {
    super.onReady();

    let commentContainer = document.querySelector('.provider-wrap [data-comments] .inner-wrap');
    let page = 0;

    $('[data-comments]', context).each(function(){
      let commentsID = $(this).attr('data-comments');

      commentsInit(commentsID);

    });

    function buildComments(data) {
      data.comments.forEach(value => {
        let container = context.createElement('div');
        container.classList.add('comment-wrap');

        let commentWrap = context.createElement('p');
        commentWrap.classList.add('comment');
        let comment = value.text;
        commentWrap.textContent = comment;

        let dateWrap = context.createElement('p');
        dateWrap.classList.add('date');

        // the date produces a string for month, day, and year. the desire was to just have month and year.
        // so we're going to split the string apart in order to make that date format.
        let date = value.date.split(' ');
        date = `${date[0]} ${date[2]}`;
        dateWrap.textContent = date;

        container.appendChild(commentWrap);
        container.appendChild(dateWrap);

        commentContainer.appendChild(container);
      })
    }


    function buildTotalComments(data) {
      let totalCommentsWrap = document.querySelector('.provider-wrap [data-comments] .total-comments');
      let totalComments = data.total + ' Patient Comments' ;
      totalCommentsWrap.textContent = totalComments;
    }

    function buildButton(data, id) {
      let button = context.createElement('button');
      button.classList.add('load-more');
      button.setAttribute('data-comments-id', id);
      button.textContent = 'Load More';

      button.addEventListener('click', () => {
        getComments(id);
      })

      if (data.total > 5) {
        commentContainer.after(button);
      }
    }

    function commentsInit(id) {
      $.ajax({
        url: `/provider/comments/${id}`,
        data: {
          page: page,
        }
      })
        .then(function(data){

          buildTotalComments(data);
          buildComments(data);
          buildButton(data, id);

        });
    }

    function getComments(id) {

      ++page;

      $.ajax({
        url: `/provider/comments/${id}`,
        data: {
          page: page,
        }
      })
        .then(function(data){

          buildComments(data);

          var commentCount = $('.provider-wrap [data-comments] .inner-wrap').children().length;
          if (commentCount >= data.total) {
            $('[data-comments] button.load-more').css('display', 'none');
          }

        });
    }
  }

}

DrupalBehavior.register('guthrie_fap', 'comments', Comments);
